export default __webpack_public_path__ + "ed108001fd709cbcae4114cddd574041.png";